module.exports = __webpack_public_path__ + "img/Imagem_1.7519f1fb.png";